import { ProfileEdit } from '../Components/Common/ProfileEdit'
import { ChangePassword } from '../Components/Common/ChangePassword'
import { ParentProfile } from '../Components/Common/ParentProfile'
import { ParentTask, ParentAgenda, ParentSchedule, ParentCollegeProfile } from '../Components/ParentManagement'

export const parentRoutes = [
	// Profile Routes
	{ path: `${process.env.PUBLIC_URL}/parent/profile/:layout`, Component: <ParentProfile /> },
	{ path: `${process.env.PUBLIC_URL}/parent/profile-edit/:layout`, Component: <ProfileEdit /> },
	{ path: `${process.env.PUBLIC_URL}/parent/change-password/:layout`, Component: <ChangePassword /> },

	// Parent specific routes
	{ path: `${process.env.PUBLIC_URL}/parent/task/:layout`, Component: <ParentTask /> },
	{ path: `${process.env.PUBLIC_URL}/parent/agenda/:layout`, Component: <ParentAgenda /> },
	{ path: `${process.env.PUBLIC_URL}/parent/schedule/:layout`, Component: <ParentSchedule /> },
	{ path: `${process.env.PUBLIC_URL}/parent/college-profile/:layout`, Component: <ParentCollegeProfile /> },
]
